import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export class Region{
  constructor(){}
  public regionId : number;
  public region : string
}

@Injectable({
  providedIn: 'root'
})

export class RegionsService {
  
  constructor(private httpClient:HttpClient) { }

  getRegions() : Observable<Region[]> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<Region[]>('api/v1/region/',{headers})
    .pipe(catchError(this.errorHandler));
  }

  getRegionsByUser() : Observable<Region[]> {

    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.get<Region[]>('/api/v1/region/byuser/{user_id}',{headers})
    .pipe(catchError(this.errorHandler));

  }

  public createRegion(obj : any) : Observable<any>{
    //console.log(obj);
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.post<any>('/api/v1/region/' , obj , {headers}).pipe(catchError(this.errorHandler));
  }

  
  updateRegion(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization:  sessionStorage.getItem('basicauth')  });
    return this.httpClient.put<any>('/api/v1/region/' , bean , {headers}).pipe(catchError(this.errorHandler));
  }

  deleteRegion(Id: number){
    return this.httpClient.delete('api/v1/region/' + Id);
  }

  errorHandler(error: HttpErrorResponse){
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }

}
